// extracted by mini-css-extract-plugin
module.exports = {"dmp-error-ui":"ErrorUi_dmp-error-ui__10j4v","copy-text":"ErrorUi_copy-text__If_ot"};